export default __webpack_public_path__ + "maps-examples-tracking-mode-thumbnail-480-aaa651de71d083b799fa445b7dba7aa3.webp";